export const initFlixxGrid = function (config) {
  // --- Configurable constants ---
  const COOKIE_NAME = 'flixx_corecurriculum';
  const COOKIE_DAYS = 365; // persist for one year

  // --- Small cookie helpers (no external dependency) ---
  // Set a cookie with expiration in <days>
  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/`;
  }

  // Read cookie value by name; returns null if not found
  function getCookie(name) {
    const nameEQ = name + '=';
    const parts = document.cookie.split(';');
    for (let i = 0; i < parts.length; i++) {
      let c = parts[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  // Cache selector strings for clarity
  const ROWS_SEL = '.flixx_grid .grid .row';
  const COL_SEL = '.col-md-4';
  const CORE_COL_SEL = '.col-md-4.corecurriculum';

  // Persist original order indices once per column so we can restore later
  function captureOriginalOrder() {
    $(ROWS_SEL).each(function () {
      $(this).children(COL_SEL).each(function (idx) {
        // Store both as data() and attribute for safety across detach/insert
        if ($(this).data('origIndex') === undefined) {
          $(this).attr('data-orig-index', idx);
          $(this).data('origIndex', idx);
        }
      });
    });
  }

  // Apply sorting depending on the toggle state
  function applySorting(enable) {
    $(ROWS_SEL).each(function () {
      const $row = $(this);

      if (enable) {
        // Move .corecurriculum cards to the top, preserving their relative order
        const $core = $row.children(CORE_COL_SEL);
        for (let i = $core.length - 1; i >= 0; i--) {
          // Prepend in reverse so final order matches original DOM order
          $row.prepend($core[i]);
        }
      } else {
        // Restore original order by data-orig-index
        const $children = $row.children(COL_SEL).get();
        $children.sort(function (a, b) {
          const ai = parseInt($(a).attr('data-orig-index') || $(a).data('origIndex') || 0, 10);
          const bi = parseInt($(b).attr('data-orig-index') || $(b).data('origIndex') || 0, 10);
          return ai - bi;
        });
        // Append back in sorted order
        $row.append($children);
      }
    });
  }

  // --- Init sequence ---
  if ($('.flixx_grid').length === 0) {
    return; // nothing to do
  }

  // Capture original order once on init
  captureOriginalOrder();

  const $checkbox = $('#corecurriculum');
  if ($checkbox.length) {
    // Initialize checkbox state from cookie
    const saved = getCookie(COOKIE_NAME);
    const enabled = saved === '1';
    if (enabled) {
      $checkbox.prop('checked', true);
    }

    // Apply initial sorting based on current state
    applySorting($checkbox.is(':checked'));

    // Listen for changes and persist + (re)sort
    $checkbox.on('change', function () {
      const isOn = $(this).is(':checked');
      setCookie(COOKIE_NAME, isOn ? '1' : '0', COOKIE_DAYS);
      applySorting(isOn);
    });
  } else {
    // No checkbox present; just ensure normal order (cookie off by default)
    applySorting(false);
  }
};
